// The trip-type radios on the booking widget show "single" or "round trip". The form state
// normally holds one of four values: 'single', 'inbound' and 'outbound' are one-way trips,
// 'with_retour' is a round trip. The value can also come unchecked from the URL. On the first
// render the form is still empty, so the value is undefined. Only a known one-way value may
// check the single radio.
//
// The decision lives here, outside the React component, so that `node --test` covers it. The
// file is .mjs so that `node --test` loads it as an ES module; Vite resolves the extension-less
// import.
const singleTransferTypes = ['single', 'inbound', 'outbound'];

function isSingleTransferType(transferType) {
    return singleTransferTypes.includes(transferType);
}

export { isSingleTransferType };
